import { render, staticRenderFns } from "./AfterSalesLog.vue?vue&type=template&id=1a9fee56&scoped=true&"
import script from "./AfterSalesLog.vue?vue&type=script&lang=js&"
export * from "./AfterSalesLog.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesLog.vue?vue&type=style&index=0&id=1a9fee56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9fee56",
  null
  
)

export default component.exports